module.exports = __webpack_public_path__ + "static/images/unlock_btn.7719149.png";